var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_c('img',{staticClass:"error-img",attrs:{"src":_vm.errorImg}}),_c('p',{staticClass:"error-tips"},[_vm._v(_vm._s(_vm.$_t('抱歉，您没有权限访问该页面。')))])])}
var staticRenderFns = []

export { render, staticRenderFns }